/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Article } from '../models/article';
import { getArticlesByMagasin } from '../fn/magasin-controller/get-articles-by-magasin';
import { GetArticlesByMagasin$Params } from '../fn/magasin-controller/get-articles-by-magasin';
import { getMagasinByTechnicien } from '../fn/magasin-controller/get-magasin-by-technicien';
import { GetMagasinByTechnicien$Params } from '../fn/magasin-controller/get-magasin-by-technicien';
import { inventorierArticle } from '../fn/magasin-controller/inventorier-article';
import { InventorierArticle$Params } from '../fn/magasin-controller/inventorier-article';
import { Magasin } from '../models/magasin';
import { sortirArticle } from '../fn/magasin-controller/sortir-article';
import { SortirArticle$Params } from '../fn/magasin-controller/sortir-article';

/**
 * Gestion des magasins.
 */
@Injectable({ providedIn: 'root' })
export class MagasinControllerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `inventorierArticle()` */
  static readonly InventorierArticlePath = '/v1/magasins/{id-magasin}/inventorier';

  /**
   * inventorierArticle.
   *
   * Inventorie des articles du magasin.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inventorierArticle()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inventorierArticle$Response(
    params: InventorierArticle$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<{}>> {
    return inventorierArticle(this.http, this.rootUrl, params, context);
  }

  /**
   * inventorierArticle.
   *
   * Inventorie des articles du magasin.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `inventorierArticle$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  inventorierArticle(params: InventorierArticle$Params, context?: HttpContext): Observable<{}> {
    return this.inventorierArticle$Response(params, context).pipe(map((r: StrictHttpResponse<{}>): {} => r.body));
  }

  /** Path part for operation `sortirArticle()` */
  static readonly SortirArticlePath = '/v1/magasins/{id-magasin}/articles/{code-article}/sortie';

  /**
   * sortieArticle.
   *
   * Sortie d'un article du magasin.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sortirArticle()` instead.
   *
   * This method doesn't expect any request body.
   */
  sortirArticle$Response(params: SortirArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<{}>> {
    return sortirArticle(this.http, this.rootUrl, params, context);
  }

  /**
   * sortieArticle.
   *
   * Sortie d'un article du magasin.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sortirArticle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sortirArticle(params: SortirArticle$Params, context?: HttpContext): Observable<{}> {
    return this.sortirArticle$Response(params, context).pipe(map((r: StrictHttpResponse<{}>): {} => r.body));
  }

  /** Path part for operation `getArticlesByMagasin()` */
  static readonly GetArticlesByMagasinPath = '/v1/magasins/{id-magasin}/articles';

  /**
   * getArticlesByMagasin.
   *
   * Récupération des articles par magasin.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getArticlesByMagasin()` instead.
   *
   * This method doesn't expect any request body.
   */
  getArticlesByMagasin$Response(
    params: GetArticlesByMagasin$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<Article>>> {
    return getArticlesByMagasin(this.http, this.rootUrl, params, context);
  }

  /**
   * getArticlesByMagasin.
   *
   * Récupération des articles par magasin.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getArticlesByMagasin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getArticlesByMagasin(params: GetArticlesByMagasin$Params, context?: HttpContext): Observable<Array<Article>> {
    return this.getArticlesByMagasin$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Article>>): Array<Article> => r.body)
    );
  }

  /** Path part for operation `getMagasinByTechnicien()` */
  static readonly GetMagasinByTechnicienPath = '/v1/magasins/{dk-code-ressource}';

  /**
   * get.
   *
   * Récupération des magasins par technicien.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMagasinByTechnicien()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMagasinByTechnicien$Response(
    params: GetMagasinByTechnicien$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<Magasin>>> {
    return getMagasinByTechnicien(this.http, this.rootUrl, params, context);
  }

  /**
   * get.
   *
   * Récupération des magasins par technicien.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMagasinByTechnicien$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMagasinByTechnicien(params: GetMagasinByTechnicien$Params, context?: HttpContext): Observable<Array<Magasin>> {
    return this.getMagasinByTechnicien$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<Magasin>>): Array<Magasin> => r.body)
    );
  }
}
